import { atom } from "recoil";


const FlightListAtom = atom({
    default: [],
    key: 'flightList'
})

export default FlightListAtom;